import React, { useState, useEffect } from 'react';
import { FaComments, FaPalette, FaStar, FaUserTie, FaChevronDown } from 'react-icons/fa';
import { useScrollPosition } from '../hooks/useScrollPosition';
import FeatureItem from './FeatureItem';
import WorkItem from './WorkItem';
const image1 = "/work-images/kaple2.png";
const image2 = "/work-images/navrh-dum.png";
const image3 = "/work-images/koupelna1.png";
const logo = "/other-images/logo.png"; 

const backgroundImages = [
  "/work-images/uvod3.png",
  "/work-images/uvod2.png",
  "/work-images/kaple1.png"
];

const Main: React.FC = () => {
  const scrollY = useScrollPosition();
  const [showScrollButton, setShowScrollButton] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [imagesLoaded, setImagesLoaded] = useState(false);

  useEffect(() => {
    setShowScrollButton(scrollY < 25);
  }, [scrollY]);

  // Preload all background images before starting transitions
  useEffect(() => {
    const imagePromises: Promise<void>[] = [];

    backgroundImages.forEach((imageSrc) => {
      const img = new Image();
      const promise = new Promise<void>((resolve) => {
        img.onload = () => {
          resolve();
        };
        img.onerror = () => {
          // Even if one fails, continue with others
          resolve();
        };
        img.src = imageSrc;
      });
      imagePromises.push(promise);
    });

    // Wait for all images to load (or timeout after 10 seconds)
    Promise.all(imagePromises)
      .then(() => {
        setImagesLoaded(true);
      })
      .catch(() => {
        // Fallback: start transitions even if some images fail
        setImagesLoaded(true);
      });

    // Safety timeout - start transitions after 10 seconds even if images aren't loaded
    const timeout = setTimeout(() => {
      setImagesLoaded(true);
    }, 10000);

    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    // Only start transitions after images are preloaded
    if (!imagesLoaded) return;

    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % backgroundImages.length);
    }, 5000); // Change image every 5 seconds

    return () => clearInterval(interval);
  }, [imagesLoaded]);

  const scrollToWorks = () => {
    const worksSection = document.querySelector('.features-section');
    if (worksSection) {
      worksSection.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  const workItems = [
    { image: image1, alt: "Kaple", text: "Kaple, Pozořice, 2021", link: "/work/1" },
    { image: image2, alt: "Návrh domu", text: "Návrh domu, 2024", link: "/work/2" },
    { image: image3, alt: "Koupelna", text: "Koupelna, Třinec, 2025", link: "/work/3" }
  ];

  const features = [
    {
      icon: <FaComments />,
      title: "Konzultace",
      description: "Individualní konzultace přizpůsobené vašim potřebám"
    },
    {
      icon: <FaPalette />,
      title: "Návrhy",
      description: "Architektonické studie, projekční činnost, vizualizace, rekonstrukce, interiéry, urbanismus"
    },
    {
      icon: <FaStar />,
      title: "Zkušenosti",
      description: "Spolupráce na projektech se zkušenými architekty z ArchiBIM studio s.r.o."
    },
    {
      icon: <FaUserTie />,
      title: "Profesionální přístup",
      description: "Důraz na kvalitu, detail a preciznost v každém projektu"
    }
  ];

  return (
    <div className="main">
      <div 
        className="background-image background-image-zoom"
        style={{ '--bg-image': `url(${backgroundImages[currentImageIndex]})` } as React.CSSProperties}
      >
        <div className="background-darken"></div>
        <div className="welcome-text-container">
          <img src={logo} alt="DSarchitekt Logo" className="welcome-logo" />
          <h1 className="welcome-text">DS - Architekt</h1>
        </div>
      </div>
      
      <section className="features-section">
        <div className="features-container">
          {features.map((feature, index) => (
            <FeatureItem
              key={`feature-${feature.title}-${index}`}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
            />
          ))}
        </div>
      </section>

      <div className="works-gallery">
        {workItems.map((item, index) => (
          <WorkItem 
            key={`work-${item.alt}-${index}`}
            image={item.image} 
            alt={item.alt} 
            text={item.text}
            link={item.link}
          />
        ))}
      </div>
      <div className="fadeUp">
      {/* <Link to="/works" className="show-all-button">Zobrazit vše</Link> */}
      </div>
      {/* Scroll Down Button */}
      {showScrollButton && (
        <button 
          className="scroll-down-button"
          onClick={scrollToWorks}
          aria-label="Scroll down to see work items"
        >
          <FaChevronDown />
        </button>
      )}
    </div>
  );
};

export default Main;
